import {Platform} from 'react-native';

/**
 * Haptic confirmation for meaningful moments (HIG: use haptics to confirm
 * actions and signal errors). Lazy-required and failure-tolerant so the web
 * bundle and test environments never touch the native module.
 */
const trigger = type => {
  if (Platform.OS === 'web') {
    return;
  }
  try {
    // eslint-disable-next-line global-require
    const haptic = require('react-native-haptic-feedback').default;
    haptic.trigger(type, {
      enableVibrateFallback: false,
      ignoreAndroidSystemSettings: false,
    });
  } catch (_e) {
    // Native module unavailable (tests, unsupported device) — stay silent.
  }
};

export const hapticSuccess = () => trigger('notificationSuccess');
export const hapticError = () => trigger('notificationError');
export const hapticSelection = () => trigger('selection');
